import "./VideoScribeInNumbers.css";

import React, { useEffect } from "react";
import { useCountUp } from "react-countup";
import { useInView } from "react-intersection-observer";

interface VideoScribeInNumbersProps {
  videosCreated: string;
  users: string;
  images: string;
  countries: string;
}

const VideoScribeInNumbers: React.FC<VideoScribeInNumbersProps> = ({
  videosCreated,
  users,
  images,
  countries,
}) => {
  const { ref, inView } = useInView();
  const [started, setStarted] = React.useState(false);

  const countUpVideos = React.useRef(null);
  const countUpUsers = React.useRef(null);
  const countUpImages = React.useRef(null);
  const countUpCountries = React.useRef(null);
  const { start: startVideo } = useCountUp({
    end: parseInt(videosCreated),
    ref: countUpVideos,
  });
  const { start: startUsers } = useCountUp({
    end: parseInt(users),
    ref: countUpUsers,
  });
  const { start: startImages } = useCountUp({
    end: parseInt(images),
    ref: countUpImages,
  });
  const { start: startCountries } = useCountUp({
    ref: countUpCountries,
    end: parseInt(countries),
  });

  useEffect(() => {
    if (inView && !started) {
      setStarted(true);
      startVideo();
      startUsers();
      startCountries();
      startImages();
    }
  }, [inView, started]);

  return (
    <div className="VideoScribeInNumbers" ref={ref}>
      <div className="VideoScribeInNumbers__unit">
        <span>
          <span ref={countUpUsers} />
          <span className="VideoScribeInNumbers__lime"> million</span>
        </span>
        <p>Users worldwide</p>
      </div>
      <div className="VideoScribeInNumbers__unit">
        <span>
          <span ref={countUpVideos} />
          <span className="VideoScribeInNumbers__lime">+</span>
        </span>
        <p>Videos created daily</p>
      </div>
      <div className="VideoScribeInNumbers__unit">
        <span>
          <span ref={countUpImages} />
          <span className="VideoScribeInNumbers__lime"> million</span>
        </span>
        <p>Images in our library</p>
      </div>
      <div className="VideoScribeInNumbers__unit">
        <span>
          <span ref={countUpCountries} />
          <span className="VideoScribeInNumbers__lime">+</span>
        </span>
        <p>Countries worldwide</p>
      </div>
    </div>
  );
};

export default VideoScribeInNumbers;
